import styled, { css } from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'
import { isMobileOrIPad } from 'utils/device'

const preventDrag = css`
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
`
export const Wrapper = styled.div`
    height: 100vh;
    width: 100vw;
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    background: url(/assets/plant-1.svg) 101% 0% no-repeat,
        url(/assets/plant-2.svg) -3% 100% no-repeat,
        url(/assets/poh.svg) 75% bottom no-repeat,
        url(/assets/auth-bg.svg) top center no-repeat;
    background-size: 11%, auto, auto, contain;
    background-color: white;
    align-items: center;
    justify-content: center;
    ${() => preventDrag}

    ${applyIPadOnlyStyle('background: white', {
        orientation: 'both',
        min: 0,
        max: 1370,
        shouldApplyStyle: isMobileOrIPad,
    })}
`

export const Logo = styled.a`
    position: absolute;
    top: 4%;
    left: 2%;
    text-decoration: none;
    ${() => preventDrag}

    ${applyIPadOnlyStyle('display: none', {
        orientation: 'both',
        min: 0,
        max: 1370,
        shouldApplyStyle: isMobileOrIPad,
    })}
`
